import { isSome } from '../common/utils/maybe';
import { ResourceRole } from '../scheduling/types';
export function isEventResourceCrew(resource) {
    return [ResourceRole.fo, ResourceRole.pic].includes(resource.role);
}
export function getCrewCount(reservation) {
    return reservation.resources.filter(isEventResourceCrew).length;
}
export function getCancelledLegInfo(params) {
    var _a;
    return (_a = params.reservation.cancelledLegs) === null || _a === void 0 ? void 0 : _a.find((leg) => leg.eventId === params.childEvent.id);
}
export function isLegCancelled(params) {
    return params.reservation.slsCancelled || params.reservation.opsCancelled || isSome(getCancelledLegInfo(params));
}
//# sourceMappingURL=reservationFacts.js.map